module.exports = __webpack_public_path__ + "img/oidc-logo.2bd5b3d3.svg";